import { AgGridCellTooltipComponent } from '@anduin/shared';
import { ColDef } from 'ag-grid-community';

export function addValueTooltip(displayAsList = false): Partial<ColDef> {
  return {
    cellRenderer: AgGridCellTooltipComponent,
    cellRendererParams: {
      tooltip: {
        getContent: ({ valueFormatted, value }) => {
          const valueToShow = valueFormatted ?? value;

          if (!valueToShow || (typeof valueToShow === 'string' && valueToShow.length < 25)) {
            return;
          }

          if (!displayAsList) {
            return valueToShow;
          }

          return `
              <ul class="ul-indent d-flex flex-column ta--left">
                ${valueToShow.split(',').map(item => `<li><p class="text-nowrap truncate">${item}</p></li>`).join('')}
              </ul>
            `;
        },
      },
    },
  };
}
